const populationFrequencyStudies = [
	/*{
		id: "population_frequency",
		label: "1000 genomes",
		populations: [ "ALL", "EUR", "AMR", "AFR", "EAS", "IBS", "SAS" ],
	},
	{
		id: "GNOMAD_GENOMES",
		label: "gnomAD genomes",
		populations: [ "ALL", "NFE", "AMR", "AFR", "EAS", "SAS" ],
	},
	{
		id: "GNOMAD_EXOMES",
		label: "gnomAD exomes",
		populations: [ "ALL", "NFE", "AMR", "AFR", "EAS", "SAS" ],
	},
	{
		id: "ESP6500",
		label: "ESP6500",
		populations: [ "EA", "AA" ],
	},*/
	{
		id: "Spanish CNVs DB",
		label: "Spanish CNVs DB",
		populations: [ "ALL" ],
	},
];


export default populationFrequencyStudies;